<div fxLayout="row" fxLayoutAlign="center center" class="error-page-wrap">
  <mat-card class="error-card">

    <div class="error-hero" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center">
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <mat-icon class="error-hero-icon">cloud_off</mat-icon>
      </div>
      <div class="error-hero-divider"></div>
      <div class="error-panel" fxLayout="column" fxLayoutAlign="center center" fxFlex>
        <h1 class="error-code">503</h1>
        <div class="error-status">SERVICE UNAVAILABLE</div>
      </div>
    </div>

    <mat-card-content class="error-body" fxLayout="column" fxLayoutAlign="center center">
      <p class="error-message">Application is not available at the moment. Please try again later.</p>
      <div class="error-actions" fxLayout="row" fxLayoutAlign="center center">
        <button mat-stroked-button class="btn-outline-dark" (click)="goHome()">
          <mat-icon>home</mat-icon>
          Go to Home
        </button>
      </div>
    </mat-card-content>

  </mat-card>
</div>